module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pback10-9bcf03612b6c0e8206d906631623db53.jpg";